// @flow

import type { AppState } from 'stores'
import {
  DesktopDropdown,
  MobileDropdown
} from 'components/selector/dropdownComponents'
import { branch, renderComponent } from 'recompose'
import { connect } from 'react-redux'

const showMobileVersion = (hasTouch, mobileComponent) =>
  branch(hasTouch, renderComponent(mobileComponent))

const enhance = showMobileVersion(props => props.hasTouch, MobileDropdown)

function mapStateToProps ({ interactionCapabilities }: AppState) {
  return {
    hasTouch: interactionCapabilities.touch
  }
}

export default connect(mapStateToProps)(enhance(DesktopDropdown))



// WEBPACK FOOTER //
// ./src/components/selector/dropdownContainer.js